import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import styles from "./jogadorInput.module.css";
import { useSelector, useDispatch } from "react-redux";
import { setPlayer1, setPlayer2 } from "../../store/slices/players";

export default function JogadorInput({
  name,
  gender,
  defaultValue,
  setAvatarModal,
}) {
  const { t } = useTranslation();
  const { player1, player2 } = useSelector((state) => state.players);
  const dispatch = useDispatch();

  let genderIcon =
    gender === 0
      ? require("../../assets/icons/homem.png")
      : require("../../assets/icons/mulher.png");

  const getPlaceholder = () => {
    return gender === 0 ? t("nomeHomem1") : t("nomeMulher1");
  };

  const handleImageChange = (e) => {
    try {
      const file = e.target.files[0];
      if (name === "player1") {
        dispatch(setPlayer1({ avatar: URL.createObjectURL(file) }));
      }
      if (name === "player2") {
        dispatch(setPlayer2({ avatar: URL.createObjectURL(file) }));
      }
      setAvatarModal(0);
    } catch (error) {}
  };

  const getImage = () => {
    if (name === "player1" && player1.avatar) {
      return player1.avatar;
    }
    if (name === "player2" && player2.avatar) {
      return player2.avatar;
    }

    return "";
  };

  const onChangeAvatar = () => {
    if (name === "player1") {
      setAvatarModal(1);
    } else {
      setAvatarModal(2);
    }
  };

  const getIsAvatar = () => {
    let avatar = "";
    if (name === "player1") {
      avatar = player1.avatar;
    }
    if (name === "player2") {
      avatar = player2.avatar;
    }

    if (avatar.includes("https://desafios-picantes-bucket.dev12br.com")) {
      avatar = avatar.replace(
        "https://desafios-picantes-bucket.dev12br.com",
        ""
      );
    } else {
      avatar = "";
    }

    return avatar;
  };

  return (
    <div>
      <div className={styles.container}>
        <input
          className="hidden"
          type="file"
          accept="image/*"
          name={`${name}-image`}
          id={`${name}-image`}
          onChange={handleImageChange}
        />
        <input
          type="hidden"
          name={`${name}-image-avatar`}
          value={getIsAvatar()}
        />
        <button
          type="button"
          className={styles.avatar}
          onClick={onChangeAvatar}
        >
          <div className="img-wrapper">
            {getImage() ? <img src={getImage()} alt=" " /> : null}
          </div>
          <div className="relative">
            <div>
              <FaPlus size={12} />
            </div>
          </div>
        </button>
        <input
          defaultValue={defaultValue}
          placeholder={getPlaceholder()}
          className={styles.input}
          type="text"
          name={`${name}-name`}
        />
        <div className={styles.gender}>
          <img src={genderIcon} alt="gender" />
        </div>
      </div>
    </div>
  );
}
